import { combineReducers } from 'redux'

import { filterFieldsSlice } from './filterFields'
import { filterFieldValuesSlice } from './filterFieldValues'

export { segmentsSlice } from './segments'

export const filterReducer = combineReducers({
  [filterFieldsSlice.name]: filterFieldsSlice.reducer,
  [filterFieldValuesSlice.name]: filterFieldValuesSlice.reducer,
})
